import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    navy: {
      50: "#F5F7F8",
      100: "#E8ECEE",
      500: "#1B4748",
      600: "#163D3E",
      700: "#123334",
    },
    ink: {
      500: "#1A1A1A",
      600: "#000000",
    },
    offwhite: {
      50: "#FEFEFE",
      100: "#F9F9F9",
      200: "#F4F4F4",
    },
    accent: {
      orange: "#F8641E",
    },
  },
  fonts: {
    heading: "Georgia, 'Times New Roman', Times, serif",
    body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: "offwhite.100",
        color: "ink.500",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: "md",
        fontWeight: "500",
      },
      variants: {
        primary: {
          bg: "accent.orange",
          color: "white",
          _hover: {
            bg: "rgba(248, 100, 30, 0.85)",
          },
        },
        link: {
          color: "inherit",
          _hover: {
            textDecoration: "none",
            opacity: 0.8,
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: "500",
        lineHeight: "1.2",
      },
    },
    Text: {
      baseStyle: {
        fontWeight: "400",
        lineHeight: "1.7",
      },
    },
    Link: {
      baseStyle: {
        color: "navy.500",
        _hover: {
          textDecoration: "underline",
        },
      },
    },
  },
});

export default theme;
